// extracted by mini-css-extract-plugin
export default {"header":"Query_header__3cYiF","title":"Query_title__5P++7","ans":"Query_ans__RA4B2","sub":"Query_sub__SB9zb"};